import { BrowserRouter } from "react-router-dom";
import ApplicationRoutes from "./ApplicationRoutes";
import { Security } from "@okta/okta-react";
import { OktaAuth, toRelativeUrl } from "@okta/okta-auth-js";
import { AppMessageDisplay, AppStatusProvider, getSecurityProvider } from "@wexinc/wex-common-web";
import { useEffect } from "react";
import { Env } from "util/environment-helper";

let baseUrl = window.location.origin;
if (Env.proxyPath) {
  baseUrl = `${window.location.origin}/${Env.proxyPath}`;
}

const oktaAuth = new OktaAuth({
  clientId: Env.oktaClientId,
  issuer: Env.oktaIssuer || "",
  redirectUri: `${baseUrl}/login/callback`,
  scopes: ["openid", "profile", "email"],
  pkce: true,
  services: { autoRenew: false },
});

const ApiVersionString = Env.apiRoot?.startsWith("/")
  ? `COP API Version: ${baseUrl}${Env.apiRoot}/public/management/versions`
  : `COP API Version: ${Env.apiRoot}/public/management/versions`;

const restoreOriginalUri = (_oktaAuth: OktaAuth, originalUri: string) => {
  // After handling an okta login callback, this function is called, redirecting the user
  // back to the original URL where the login was initiated
  let proxyPath = "/"
  if (Env.proxyPath) {
    proxyPath = `/${Env.proxyPath}/`;
  }
  window.location.replace(toRelativeUrl(originalUri || proxyPath, window.location.origin));
};

function App() {
  useEffect(() => {
    oktaAuth.start();
    // log app + api versions on load for debugging purposes - WSD-625
    console.log(`COP Web Version: ${__APP_VERSION__}`);
    console.log(ApiVersionString);
  }, []);

  

  const SecurityProvider = getSecurityProvider();

  return (
    <BrowserRouter  basename={Env.proxyPath}>
      <AppStatusProvider>
        <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri} >
          <SecurityProvider>
            <AppMessageDisplay />
            <ApplicationRoutes />
          </SecurityProvider>
        </Security>
      </AppStatusProvider>
    </BrowserRouter>
  );
}

export default App;

export const __DEV = import.meta.env.NODE_ENV === "development";
